export default [
  {name: 'Шаг 1'},
  {name: 'Шаг 2'}
]
